import React, { useState, useEffect } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import { DatePicker } from "..";
import {
  DateRangePickerProps,
  DateRangePickerValueType,
} from "../../utils/types/components";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorText: {
      color: theme.palette.error.main,
      marginTop: theme.spacing(1),
    },
    helperText: {
      marginTop: theme.spacing(1),
    },
  }),
);

export const DateRangePicker = ({
  onChange,
  startDateLabel,
  endDateLabel,
  startValue,
  endValue,
  helperText,
  error,
}: DateRangePickerProps): React.ReactElement => {
  const classes = useStyles();

  const [value, setValue] = useState<
    [DateRangePickerValueType, DateRangePickerValueType]
  >([null, null]);

  useEffect(() => {
    /** Para que no se llame cuando recien a sido renderizado con valores de inicio
     *  O para cuando se coloca la misma fecha que se tenia antes
     */
    if (startValue !== value[0] || endValue !== value[1]) onChange(value);
  }, [value]);

  return (
    <div>
      <DatePicker
        label={startDateLabel}
        defaultValue={new Date()}
        value={startValue === undefined ? value[0] : startValue}
        onChange={(v) => setValue([v, value[1]])}
        error={error}
      />
      <DatePicker
        label={endDateLabel}
        defaultValue={new Date()}
        value={endValue === undefined ? value[1] : endValue}
        onChange={(v) => setValue([value[0], v])}
        error={error}
      />

      {!helperText && error && (
        <Typography
          variant="body2"
          className={error ? classes.errorText : classes.helperText}>
          Valor invalido
        </Typography>
      )}
      {helperText && (
        <Typography
          variant="body2"
          className={error ? classes.errorText : classes.helperText}>
          {helperText}
        </Typography>
      )}
    </div>
  );
};
